export default __webpack_public_path__ + "aa63837b8c45934fc57813847c6b6144.svg";